import { useGetUserAffiliates } from "../../../../core/services/react-query/user";
import { useProfileQuery } from "../../../../core/services/react-query/profile";
import styled from "styled-components";
import { CFlex, DText, Flex } from "../../../../styles/CommonStyles";
import { forwardRef, useEffect, useRef, useState } from "react";
import UserLink from "../../../common/utils/UserLink";
import NoData from "../../../common/utils/NoData";
import Loader from "../../../common/loading/Loader";
import { useWindowSize } from "../../../../core/hooks/common/useWindowSize";
import { CacheKeys, userAffiliatesFilterOptions } from "../../../../core/constants/filter";
import { useParams } from "react-router-dom";
import { TABLET_SIZE } from "../../../../core/constants/common";
import { UserDetailListWrapper } from "../../../../styles/main/user";
import FilterLayout from "../../../layout/filter/FilterLayout";
import AffiliatesTable from "./affiliates/AffiliatesTable";
import RAffiliatesTable from "./affiliates/RAffiliatesTable";



const UserAffiliate = ({ user }) => {
    const { width } = useWindowSize()
    const params = useParams()
    const [affiliates, setAffiliates] = useState({ loading: true, data: null })
    const onQuerySuccess = res => setAffiliates(res)

    const ActiveComp = width > TABLET_SIZE ? AffiliatesTable : RAffiliatesTable

    return (
        <UserDetailListWrapper>
            <FilterLayout
                query={useGetUserAffiliates}
                options={userAffiliatesFilterOptions}
                onQuerySuccess={onQuerySuccess}
                cache={CacheKeys.AFFILIATE_LIST}

                extra={{ 'userId': params.id }}
            >
                <ActiveComp data={affiliates} />
            </FilterLayout>
        </UserDetailListWrapper>
    )
}



export default UserAffiliate
